import { limitWorkspaceDirectories, MAX_WORKSPACE_DIRECTORIES, } from '#pplx/frontend/apps/ask/ask-input/ask-input-types/index.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { createZustandContext } from '#pplx/frontend/zustand-context/createZustandContext.js';
import React, { createRef } from 'react';
import { create } from 'zustand';
export const dest = createZustandContext('AskInputContext', (initial) => create((set, get) => ({
    activeMenu: null,
    fileUploadUpsellTooltipOpen: false,
    suggestions: EMPTY_ARRAY,
    // null to avoid opening blank state suggestions on initial load once fetched
    // effect in useBlankStateSuggest skips setting suggestions on first render
    blankStateSuggestions: {
        [SearchMode.SEARCH]: null,
        [SearchMode.RESEARCH]: null,
        [SearchMode.STUDY]: null,
        [SearchMode.AGENTIC_RESEARCH]: null,
        [SearchMode.BROWSER_AGENT]: null,
        [SearchMode.ASI]: null,
    },
    showSuggestDropdown: false,
    shouldUnsetSuggestionsOnUnfocus: false,
    browserAgentAllowOnceFromToggle: false,
    attachments: undefined,
    forceEnableBrowserAgent: false,
    workspaceDirectories: limitWorkspaceDirectories(initial.workspaceDirectories),
    actions: {
        onActiveMenuChange: (menu) => {
            set({ activeMenu: menu });
        },
        closeActiveMenuIfCurrent: (menu) => {
            if (get().activeMenu === menu) {
                set({ activeMenu: null });
            }
        },
        setFileUploadUpsellTooltipOpen: (open) => {
            set({ fileUploadUpsellTooltipOpen: open });
        },
        setSuggestions: (suggestions, unsetOnUnfocus = false) => {
            set({ suggestions, shouldUnsetSuggestionsOnUnfocus: unsetOnUnfocus });
        },
        setBlankStateSuggestions: (suggestions, searchMode) => {
            const blankStateSuggestions = get().blankStateSuggestions;
            set({
                blankStateSuggestions: {
                    ...blankStateSuggestions,
                    [searchMode]: suggestions,
                },
            });
        },
        setShowSuggestDropdown: (show) => {
            set({ showSuggestDropdown: show });
        },
        setBrowserAgentAllowOnce: (enabled) => {
            set({ browserAgentAllowOnceFromToggle: enabled });
        },
        setAttachments: (attachments) => {
            set({ attachments });
        },
        setForceEnableBrowserAgent: (enabled) => {
            set({ forceEnableBrowserAgent: enabled });
        },
        addWorkspaceDirectory: (dir) => {
            const { workspaceDirectories } = get();
            if (workspaceDirectories.length >= MAX_WORKSPACE_DIRECTORIES)
                return;
            if (workspaceDirectories.some((d) => d.path === dir.path))
                return;
            set({ workspaceDirectories: [...workspaceDirectories, dir] });
        },
        removeWorkspaceDirectory: (path) => {
            const { workspaceDirectories } = get();
            set({ workspaceDirectories: workspaceDirectories.filter((d) => d.path !== path) });
        },
        setWorkspaceDirectories: (dirs) => {
            set({ workspaceDirectories: limitWorkspaceDirectories(dirs) });
        },
    },
    inputRef: createRef(),
})));
const useSelector = dest.useSelector;
const useTrackedState = dest.useTrackedState;
export const AskInputContext = dest.Context;
export const useAskInputActions = () => useSelector((state) => state.actions);
export const useAskInputState = useTrackedState;
//# sourceMappingURL=AskInputProviderShared.js.map